/* eslint-disable import/no-extraneous-dependencies */
import { useState, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { ROUTES } from '@/AppRoutes';
import HomeLocation from '@/Assets/Images/location-home.png';
import SchoolLocation from '@/Assets/Images/location-school.png';
import BackgroundImage from '@/Assets/Images/stage-background.png';
import Logo from '@/Assets/Images/swiftpal-logo.svg?url';
import useSendEvents from '@/hooks/util/useSendEvents';

enum LocationEnum {
  Home = 'home',
  School = 'school',
}

interface LocationSelectionProperties {
  onLocationSelected: (location: LocationEnum) => void;
}

export default function LocationSelection({
  onLocationSelected,
}: LocationSelectionProperties): ReactElement {
  const [selectedLocation, setSelectedLocation] = useState<LocationEnum | undefined>();
  const { t } = useTranslation(['translation', 'atHome']);
  const navigate = useNavigate();
  const { locationSelectedEvent } = useSendEvents();

  const onHomeClick = () => {
    setSelectedLocation(LocationEnum.Home);
    localStorage.setItem('accessLocation', 'home');
    locationSelectedEvent('Home');
    navigate(ROUTES.AT_HOME);
  };
  const onSchoolClick = () => {
    setSelectedLocation(LocationEnum.School);
    localStorage.setItem('accessLocation', 'school');
    locationSelectedEvent('School');
    onLocationSelected(LocationEnum.School);
  };

  return (
    <div
      className="absolute inset-0 flex h-screen w-screen animate-fadeIn flex-col bg-cover bg-no-repeat opacity-0"
      style={{
        backgroundImage: `url(${BackgroundImage})`,
      }}
    >
      <div className="flex w-full flex-1 items-center justify-center">
        <div className="grid grid-cols-2 gap-[101px]">
          <button
            type="button"
            className={`relative h-[360px] w-[285px] border-[6px] ${
              selectedLocation === LocationEnum.Home
                ? 'rounded-[34px] border-primary-yellow-3'
                : 'rounded-[34px] border-neutral-white'
            } `}
            onClick={onHomeClick}
          >
            <img
              src={HomeLocation}
              alt="home"
              className="object-fit inset-0 h-full w-full rounded-[26px]"
            />
            <p
              className="absolute bottom-6 left-1/2 -translate-x-1/2 font-dynapuff text-[2.625rem] font-semibold text-neutral-white"
              style={{ WebkitTextStroke: '15px #386AF6', paintOrder: 'stroke fill' }}
            >
              {t('atHome:home')}
            </p>
          </button>
          <button
            type="button"
            className={`relative h-[360px] w-[285px] border-[6px] ${
              selectedLocation === LocationEnum.School
                ? 'rounded-[34px] border-primary-yellow-3'
                : 'rounded-[34px] border-neutral-white'
            } `}
            onClick={onSchoolClick}
          >
            <img
              src={SchoolLocation}
              alt="home"
              className="object-fit inset-0 h-full w-full rounded-[26px]"
            />
            <p
              className="absolute bottom-6 left-1/2 -translate-x-1/2 font-dynapuff text-[2.625rem] font-semibold text-neutral-white"
              style={{ WebkitTextStroke: '15px #386AF6', paintOrder: 'stroke fill' }}
            >
              {t('atHome:school')}
            </p>
          </button>
        </div>
      </div>
      <div className="absolute bottom-8 right-8">
        <img src={Logo} alt="logo" className="h-full w-full" />
      </div>
    </div>
  );
}
